import EnquirySlider from './EnquirySlider.component';

export default EnquirySlider;